//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import MessageIcon from '@material-ui/icons/Message';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { NO_MESSAGES_TO_DISPLAY, ONLY_EMPLOYERS_CAN_INITIATE_THREAD } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';
// import _set from 'lodash/set';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            // alignItems: 'center',
            height: '100%',
        },
        noThreadMessageIcon: {
            width: '100%',
            fontSize: 140,
            color: '#F0F2F6',
            marginBottom: 27,
        },
        noThreadMessage1Text: { textAlign: 'center', fontWeight: 600, marginBottom: 8 },
        noThreadMessage2Text: { textAlign: 'center', fontSize: 15 },
        hidden: {
            display: 'none',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props
    } = params;
    // const { hidden: hiddenCls } = classes;

    const defns = {
        // noThreadMessageIcon: {},
        noThreadMessage1Text: {
            variant: 'h6',
            value: NO_MESSAGES_TO_DISPLAY,
        },
        noThreadMessage2Text: {
            variant: 'body2',
            value: ONLY_EMPLOYERS_CAN_INITIATE_THREAD,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ThreadDetailNoThreads = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    // const context = useContext(LayoutContext);

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { isHidden } = props;

    //---------------------------------------------------------------------
    // useCallback hook
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return isHidden ? null : (
        <div {...defns.root}>
            <MessageIcon {...defns.noThreadMessageIcon} />
            <AfitdTypography value={NO_MESSAGES_TO_DISPLAY} {...defns.noThreadMessage1Text} />
            <AfitdTypography value={ONLY_EMPLOYERS_CAN_INITIATE_THREAD} {...defns.noThreadMessage2Text} />
        </div>
    );
};

export default ThreadDetailNoThreads;
